<template>
  <div class="wrap">
      <a-layout class="banner-wrap">
        <div class="banner">
          <a-carousel arrows :autoplay="true">
            <div
              slot="prevArrow"
              class="custom-slick-arrow"
              style="left: 10px;zIndex: 1"
            >
              <a-icon type="left-circle" />
            </div>
            <div
              slot="nextArrow"
              class="custom-slick-arrow"
              style="right: 10px"
            >
              <a-icon type="right-circle" />
            </div>
            <div
              v-for="(item, i) in bannerImg"
              :key="i"
              class="bannerImg"
              :style="{'background-image': 'url(' + item.url  + ')'}"
            >
              <div class="banner-cover">
                <h1 class="join-title">{{ item.title }}</h1>
                <h3 class="join-subtitle">{{ item.subtitle }}</h3>
              </div>
            </div>
          </a-carousel>
        </div>
      </a-layout>
      <a-layout class="main-content">
        <div class="card-wrap">
          <a-card
            v-for="(p, i) in partner"
            :key="i"
            hoverable
            class="product-card"
          >
            <img
              alt="partner"
              :src="p.img"
              slot="cover"
              style="width:100%;"
            />
            <div solt="description" v-html="p.desc"></div>
          </a-card>
        </div>
        <a-card title="主营产品">
          <div class="mainProduct">
            <a-card-grid
              v-for="(e, i) in produceText"
              :key="i"
              style="textAlign:'center'"
              class="productWidth"
            >
              <div style="display:flex;align-items:center;">
                <img :src="e.img" :alt="e.text" width="100px" style="margin: 5px">
                <span>{{e.text}}</span>
              </div>
            </a-card-grid>
          </div>
        </a-card>
      </a-layout>
  </div>
</template>

<script>
import appConf from "@/config/config";

export default {
  name: "Index",
  data() {
    return {
      bannerImg: appConf.bannerImg,
      product: appConf.product,
      partner: [
        {
          img: "/static/img/index/hzhb1.png",
          desc: `
                <img src="/static/img/index/hzhb11.png" width="100px" style="margin:20px">
                <h3>Texas Instruments Incorporated</h3>
                <h5 style="color:#2291b7">品牌优势：数字信号处理器与模拟电路</h5>
                <p>现货库存主要包括TI产品的如下系列</p>
                <p>*数字信号处理器（DSP）</p>
                <p>*微控制器（MCU）</p>
                <p>*电源管理</p>
                <p>*数据转换器</p>
                <p>*放大器</p>
                <p>*无线产品</p>
          `
        },
        {
          img: "/static/img/index/hzhb2.png",
          desc: `<img src="/static/img/index/hzhb22.png" width="100px" style="margin:20px">
                <h3>Analog Device Inc</h3>
                <h5 style="color:#2291b7">品牌优势：数据转换和信号处理技术，全球领先</h5>
                <p>现货库存主要包含亚德诺半导体的如下系列</p>
                <p>*放大器与线性产品</p>
                <p>*数据与信号转换</p>
                <p>*接口和隔离产品</p>
          `
        },
        {
          img: "/static/img/index/hzhb3.png",
          desc: `<img src="/static/img/index/hzhb33.png" width="100px" style="margin:20px">
                <h3>SGS-THOMSON Microelectronics</h3>
                <h5 style="color:#2291b7">品牌优势：模拟芯片和电源转换芯片</h5>
                <p>现货库存主要包括STM产品的如下系列</p>
                <p>*微控制器</p>
                <p>*电机驱动器</p>
                <p>*存储器</p>
                <p>*无线产品</p>
                <p>ST合作伙伴计划</p>
                <p>让我们仪器打造更好的解决方案</p>
          `
        },
        {
          img: "/static/img/index/hzhb4.png",
          desc: `<img src="/static/img/index/hzhb44.png" width="100px" style="margin:20px">
                <h3>NXP Semiconductors N.V</h3>
                <h5 style="color:#2291b7">
                  品牌优势：
                  性能混合信号领域推动着互联汽车，
                  物联网设备端到端Security与数据保护等智能互联应用市场的创新。
                </h5>
                <p>现货库存主要包括NXP产品的如下系列</p>
                <p>*微处理器和控制器</p>
                <p>*无线连接</p>
                <p>*传感器</p>
                <p>*机电驱动</p>
          `
        },
        {
          img: "/static/img/index/hzhb5.png",
          desc: `<img src="/static/img/index/hzhb55.png" width="100px" style="margin:20px">
                <h3>ALTERA</h3>
                <h5 style="color:#2291b7">品牌优势：世界上第一个编程逻辑器件</h5>
                <p>现货库存主要包括ALTERA产品的如下系列</p>
                <p>*Gyclone系列</p>
                <p>*MAX系列</p>
                <p>*配置芯片系列</p>
          `
        },
        {
          img: "/static/img/index/hzhb6.png",
          desc: `<img src="/static/img/index/hzhb66.png" width="100px" style="margin:20px">
                <h3>Linear Technology Corporation</h3>
                <h5 style="color:#2291b7">品牌优势：高性能线性集成电路制作商</h5>
                <p>现货库存主要包括凌特产品的如下系列</p>
                <p>*信号调理</p>
                <p>*电源管理</p>
          `
        },
        {
          img: "/static/img/index/hzhb7.png",
          desc: `<img src="/static/img/index/hzhb77.png" width="100px" style="margin:20px">
                <h3>AVX Corporation</h3>
                <h5 style="color:#2291b7">品牌优势：专业从事无源电子元器件</h5>
                <p>现货库存主要包括AVX产品的如下系列</p>
                <p>*钽电容</p>
          `
        },        
        {
          img: "/static/img/index/hzhb8.png",
          desc: `<img src="/static/img/index/hzhb88.png" width="100px" style="margin:20px">
                <h3>Amphenol Corporation</h3>
                <h5 style="color:#2291b7">
                  品牌优势：
                  圆柱形连接器和矩形连接器，高性能连接器和线缆组件，坚固耐用，应对各类险恶地形和环境。
                </h5>
                <p>现货库存主要包括安费诺产品的如下系列</p>
                <p>*航空插头</p>
                <p>*射频元件</p>
          `
        },
        {
          img: "/static/img/index/hzhb9.png",
          desc: `<img src="/static/img/index/hzhb99.png" width="100px" style="margin:20px">
                <h3>HARTING Technology Group</h3>
                <h5 style="color:#2291b7">
                  品牌优势：
                    *重型Han连接器
                    *D-SUB连接器
                    *扁平电缆连接器
                    *微电子连接器
                    *高密度公制PCB连接器
                    *光纤数据线系统
                    *同轴电缆PCB连接器等
                </h5>
                <p>现货库存主要包括哈丁产品的如下系列</p>
                <p>*重型Han连接器</p>
                <p>*高密度公制PCB连接器</p>
                <p>*D-SUB连接器</p>
          `
        }
      ],
      produceText: [
        {
          text: "芯片",
          img: "/static/chips/xp.png",
        },
        {
          text: "电阻",
          img: "/static/chips/dz.png",
        },
        {
          text: "电容",
          img: "/static/chips/dr.png",
        },
        {
          text: "电感",
          img: "/static/chips/dg.png",
        },
        {
          text: "电位器",
          img: "/static/chips/dwq.png",
        },
        {
          text: "接插件和航插",
          img: "/static/chips/jcjhc.png",
        },
        {
          text: "晶振",
          img: "/static/chips/jz.png",
        },
        {
          text: "继电器",
          img: "/static/chips/jdq.png",
        },
        {
          text: "发光二极管",
          img: "/static/chips/fgejg.png",
        },
        {
          text: "PCB板焊接",
          img: "/static/chips/pcb.png",
        }
      ]
    };
  },
  methods: {
    init() {}
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="css" scoped>
.banner-wrap .banner {
  width: 100%;
  height: 500px;
  min-width: 300px;
  background: #666;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  overflow: hidden;
  position: relative;
}
.banner #slider {
  width: 100%;
  height: 100%;
}
.banner .banner-cover {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(30, 30, 30, 0.45);
}
.banner .banner-cover .join-title {
  color: #fff;
  line-height: 1;
  font-size: 2.5rem;
  max-height: 2.5rem;
  transition: all 300ms;
}
.banner .banner-cover .join-subtitle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 1.25rem;
  max-height: 1.25rem;
  line-height: 1;
  transition: all 300ms;
}
.ant-card-hoverable {
  box-shadow: 0 2px 8px rgba(0,0,0,.12);
}
.ant-card-hoverable:hover {
  box-shadow: 2px 4px 10px rgba(0,0,0,.24);
  border-color: rgba(0,0,0,.09);
}
.bannerImg {
  width: 100%;
  height: 100%;
  position: relative;
  min-height: 500px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.card-wrap {
  width: 80%;
  margin: 80px auto;
  display: flex;
  flex-flow: row wrap;
}
.card-wrap .product-card {
  min-width: 300px;
  width: 45%;
  margin: 20px;
}
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 500px;
  line-height: 500px;
  background: #364d79;
  overflow: hidden;
}
.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31,45,61,.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel >>> .slick-slide  h3 {
  color: #fff;
}
.main-content {
  min-height: 100vh;
}
.productWidth {
  width: 25%;
}
@media screen and (max-width: 666px) {
  .banner-wrap .banner {
    height: 250px;
  }
  .banner-wrap .banner .banner-cover .join-title {
    font-size: 24px;
  }
  .banner-wrap .banner .banner-cover .join-subtitle {
    font-size: 12px;
  }
  .bannerImg {
    min-height: 250px;
  }
  .ant-carousel >>> .slick-slide {
    height: 250px;
    line-height: 250px;
  }
  .mainProduct {
    display: flex;
    flex-direction: column;
  }
  .card-wrap {
    width: 100%;
  }
  .card-wrap .product-card {
    width: 100%;
  }
  .productWidth {
    width: 100%;
  }
}
</style>
